/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Transaction server Services 
 * These services provide APIs to interact with transaction
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ExtendedTC } from './extended-tc';

/**
 * The buyer contact which only contains extended term and condition.
 * @export
 * @interface BuyerContractWithOnlyExtendedTermCondition
 */
export interface BuyerContractWithOnlyExtendedTermCondition {
    /**
     * The full entity class name of the buyer contract.
     * @type {string}
     * @memberof BuyerContractWithOnlyExtendedTermCondition
     */
    _class?: BuyerContractWithOnlyExtendedTermConditionClassEnum;
    /**
     * The terms and condtions of the buyer contract.
     * @type {Array<ExtendedTC>}
     * @memberof BuyerContractWithOnlyExtendedTermCondition
     */
    termConditions?: Array<ExtendedTC>;
}

/**
    * @export
    * @enum {string}
    */
export enum BuyerContractWithOnlyExtendedTermConditionClassEnum {
    ComIbmCommerceTradingEntitiesBuyerContract = 'com.ibm.commerce.trading.entities.BuyerContract'
}



